import { makeStyles } from '@material-ui/core/styles';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
    '@media(width: 1024px) and (height: 768px)': {
      width: '1.75rem',
      height: '1.75rem',
    },
    '@media(width: 1600px) and (height: 1200px)': {
      width: '2.5rem',
      height: '2.5rem',
    },
    '@media(width: 1024px) and (height: 576px)': {
      width: '1.35rem',
      height: '1.35rem',
    },
    '@media(width: 1280px) and (height: 720px)': {
      width: '1.75rem',
      height: '1.75rem',
    },
    '@media(width: 1366px) and (height: 768px)': {
      width: '2rem',
      height: '2rem',
    },
    '@media(width: 1600px) and (height: 900px)': {
      width: '2.25rem',
      height: '2.25rem',
    },
    '@media(width: 1920px) and (height: 1080px)': {
      width: '2.5rem',
      height: '2.5rem',
    },
  },
  iconAlternate: {
    width: '1.7569546120058566vw',
    height: '3.125vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1.171303074670571vw',
  },
  barError: {
    backgroundColor: themeColor.alert,
  },
  barWarning: {
    backgroundColor: themeColor.alert,
  },
  barInfoDecision: {
    backgroundColor: theme.palette.secondary.main,
  },
  barNotification: {
    backgroundColor: theme.palette.primary.main,
  },
  barSuccess: {
    backgroundColor: theme.palette.secondary.main,
  },
  error: {
    color: themeColor.alert,
  },
  prohibit: {
    color: themeColor.alert,
  },
  warning: {
    color: themeColor.alert,
  },
  decision: {
    color: theme.palette.secondary.main,
  },
  info: {
    color: theme.palette.primary.main,
  },
  success: {
    color: theme.palette.secondary.main,
  },
  title: {
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: rem(2),
    marginBlockStart: '0',
    marginBlockEnd: '.5em',
    width: '90%',
    padding: '0 5%',
    color: theme.palette.primary.main,
    paddingTop: '5vh',
  },
  message: {
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: rem(1.125),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    maxWidth: '90%',
    paddingLeft: '8.784773060029282vw',
    paddingRight: '8.784773060029282vw',
    whiteSpace: 'pre-wrap',
  },
  subMessage2: {
    paddingTop: '3.5vh',
  },
  bar: {
    width: '4.831625183016105vw',
    height: '1.3020833333333333vh',
    margin: 'auto',
    marginBottom: '3.90625vh',
    marginTop: '3.90625vh',
  },
  header: {
    backgroundColor: themeColor.white,
    height: '7.29vh',
    '@media (aspect-ratio: 4/3)': {
      height: '5.76vh',
    },
    fontSize: rem(1.125),
    boxShadow: `0px 1px 2px ${themeColor.borderGray}`,
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  headerSpacing: {
    marginLeft: '1vw',
    color: themeColor.tangaroa,
  },
  grow1Shrink1: {
    overflowWrap: 'anywhere',
    paddingTop: '4vh',
    flexGrow: 1,
    flexShrink: 1,
  },
  grow1Shrink1Centered: {
    paddingTop: '0 !important',
  },
  centeredMessage: {
    display: 'flex',
    flexDirection: 'column',
  },
  centeredBar: {
    margin: '3.9vh auto',
  },
  centeredHeader: {
    marginBottom: '0',
  },
}));
